import React from 'react';
import Switch from 'components/UI/Antd/Switch/Switch';
import { Form } from 'antd';

const FormItem = Form.Item;

const AntdSwitchWithFormik = ({ label, field, form, ...props }) => {
  return (
    <div className='field-container'>
      <FormItem label={label} colon={false}>
        <Switch
          {...props}
          checked={field.value}
          onChange={checked => {
            form.setFieldValue(field.name, checked);
          }}
        />
      </FormItem>
    </div>
  );
};

export default AntdSwitchWithFormik;
